export default __webpack_public_path__ + "static/media/FG-Renewal-Form.9ce6f50b.pdf";